class ParametersController {
    constructor(
        $scope,
        $stateParams,
        $timeout,
        $location,
        $filter,
        $state,
        evaluationService,
        pedagogicalService,
        $rootScope,
        RulerService,
    ) {
        this.$location = $location;
        this.$state = $state;
        this.currentEvalId = $stateParams.id;
        this.RulerService = RulerService;
        let areaId = parseInt($stateParams.subjectAreaId);
        this.answers = [];
        this.$stateParams = $stateParams;
        this.stateChangeCheck = true;
        this.resultsMode = false;
        this.ignoredParameters = {};
        this.hiddenParameters = {};
        this.hiddenAreas = {};
        this.displayPromptOnRedirct = true;
        this.isFinished = false;
        this.state = 'parameters';
        this.showOthers = false;
        this.subjectAreaId;

        let calculateOverallScore = (matchScores) => {
            let overallScoreRoot = 0;
            let overallScoreFactors = 1;
            for (let paramResults of matchScores) {
                if (!isNaN(paramResults.accurateMatchScore)) {
                    overallScoreFactors *= paramResults.accurateMatchScore;
                    ++overallScoreRoot;
                }
            }
            let overallScore = Math.pow(overallScoreFactors, 1 / overallScoreRoot);
            if (isNaN(overallScore)) {
                return "-";
            } else {
                return (Math.round(overallScore * 100) + "%");
            }
        };

        let calculateParamScore = (parameters) => {
            let paramsMatchScores = [];
            Object.keys(parameters).forEach(function (key) {
                if (typeof parameters[key] === 'object') {
                    if (!(this.hiddenParameters[parameters[key].parameter] === true)) {
                        paramsMatchScores.push(this.RulerService.calcMatchScores(parameters[key].questions));
                    }
                }
            });
            return paramsMatchScores;
        };

        let drawScoreRuler = (paramsResults) => {
            $timeout(function () {
                let rulerLength = 210;
                let rulerOffset = 20;

                for (var i = 0; i < paramsResults.length; i++) {
                    var canvas = document.getElementById("ruler_" + i);
                    if (canvas) {
                        var ctx = canvas.getContext("2d");
                        ctx.fillStyle = "#d6e0e5";
                        ctx.fillRect(rulerOffset, 20, rulerLength, 10);

                        ctx.fillRect(rulerOffset, 12, 3, 10);
                        ctx.fillRect(rulerOffset + rulerLength - 3, 12, 3, 10);

                        ctx.fillStyle = "black";
                        ctx.textAlign = "center";
                        let textStart = "-" + paramsResults[i].maxValue;
                        ctx.fillText(textStart, rulerOffset, 10);
                        let textEnd = paramsResults[i].maxValue;
                        ctx.fillText(textEnd, rulerLength + rulerOffset, 10);

                        let step = rulerLength / (2 * paramsResults[i].maxValue);

                        if (paramsResults[i].sumGlass === paramsResults[i].sumPin) {
                            // draw Glass
                            let glassPosition = step * (paramsResults[i].sumGlass + paramsResults[i].maxValue) + rulerOffset;
                            ctx.fillText(paramsResults[i].sumGlass, glassPosition, 10);
                            ctx.lineWidth = 2;
                            ctx.beginPath();
                            ctx.arc(glassPosition, 24, 8, 0, 2 * Math.PI);
                            ctx.fillStyle = 'rgba(255, 255, 255, 0.5)';
                            ctx.fill();
                            ctx.strokeStyle = '#ff9900';
                            ctx.stroke();

                            //draw Glass line
                            ctx.beginPath();
                            ctx.moveTo(glassPosition + 5, 29);
                            ctx.lineTo(glassPosition + 10, 35);
                            ctx.stroke();
                        } else {
                            //draw Pin
                            let pinPosition = step * (paramsResults[i].sumPin + paramsResults[i].maxValue) + rulerOffset;
                            ctx.fillText(paramsResults[i].sumPin, pinPosition, 10);
                            ctx.beginPath();
                            ctx.arc(pinPosition, 21, 4, 0, 2 * Math.PI);
                            ctx.fillStyle = '#ff9900';
                            ctx.fill();
                            ctx.strokeStyle = '#ff9900';
                            ctx.stroke();

                            //draw Pin line
                            ctx.beginPath();
                            ctx.moveTo(pinPosition, 24);
                            ctx.lineTo(pinPosition, 32);
                            ctx.stroke();

                            //draw Glass
                            let glassPosition = step * (paramsResults[i].sumGlass + paramsResults[i].maxValue) + rulerOffset;
                            ctx.fillStyle = '#000000';
                            ctx.fillText(paramsResults[i].sumGlass, glassPosition, 45);
                            ctx.lineWidth = 2;
                            ctx.beginPath();
                            ctx.arc(glassPosition, 24, 8, 0, 2 * Math.PI);
                            ctx.fillStyle = 'rgba(255, 255, 255, 0.5)';
                            ctx.fill();
                            ctx.strokeStyle = '#003459';
                            ctx.stroke();

                            //draw Glass line
                            ctx.beginPath();
                            ctx.moveTo(glassPosition + 5, 29);
                            ctx.lineTo(glassPosition + 10, 35);
                            ctx.stroke();
                        }
                    }
                }
            });
        };

        let getABSkills = (data, areaId) => {
            let ABAAreaSkills;
            let AreaSkillsA;
            let AreaSkillsB;
            if (areaId) {
                ABAAreaSkills = data.learningGoals.filter(skill => skill.subjectAreaId === areaId);
            } else {
                ABAAreaSkills = data.learningGoals.filter(skill => skill.isSubjectAreaDefault === false);
            }
            AreaSkillsA = $filter('filter')(ABAAreaSkills, { importance: 'A' });
            AreaSkillsB = $filter('filter')(ABAAreaSkills, { importance: 'B' });
            return {
                A: AreaSkillsA,
                B: AreaSkillsB,
                AB: ABAAreaSkills
            };
        };

        let goToNextArea = () => {
            pedagogicalService.getAllSkills().then((data) => {
                this.defaultSubjectAreas = data;
                if (this.defaultSubjectAreas.length) {
                    const isLastIndex = areaId === this.defaultSubjectAreas[[this.defaultSubjectAreas.length - 1]].id;
                    const currentIndex = this.defaultSubjectAreas.findIndex(x => x.id === areaId);

                    this.displayPromptOnRedirct = false;
                    if (isLastIndex) {
                        this.$state.go(`mini.learningEngagement.aspect`, {
                            id: this.currentEvalId,
                            aspectNr: 0,
                            reload: true
                        });
                    } else {
                        this.$state.go(`mini.pedagogicalApproach.defaultSubjectArea`, {
                            id: this.currentEvalId,
                            subjectAreaId: this.defaultSubjectAreas[currentIndex + 1].id,
                            reload: true
                        });
                    }
                }
            });
        };

        let scrollToTop = () => {
            $timeout(function () {
                document.getElementById('topOfPage').scrollIntoView();
            }, 100);
        };

        let goToNextSkill = () => {
            let importance = this.filteredAreaSkills.AB.find(x => x.skillId === this.skillId).importance;
            let currSkillIndex;
            let nextSkillId;
            currSkillIndex = this.filteredAreaSkills[importance].findIndex(x => x.skillId === this.skillId);
            let nextSkill = this.filteredAreaSkills[importance][currSkillIndex + 1];
            if (nextSkill && (importance === 'A' || importance === 'B')) {
                nextSkillId = nextSkill.skillId;
            } else if (importance === 'A' && this.filteredAreaSkills.B.length) {
                nextSkillId = this.filteredAreaSkills.B[0].skillId;
            } else {
                nextSkillId = null;
                goToNextArea();
            }
            if (nextSkillId) {
                this.skillId = nextSkillId;
                this.skillName = this.filteredAreaSkills.AB.find(x => x.skillId === nextSkillId).name;
                this.resultsMode = false;
                scrollToTop();
            }
        };

        pedagogicalService.getAllParameters().then((dataClear) => {
            $scope.$watch('$ctrl.skillId', () => {
                this.answers = [];
                var parametersTemp = angular.copy(dataClear);
                var question, qParam, qId, qPin, qGlass, qHidden;
                this.stateChangeCheck = true;
                evaluationService.getEvaluationData(this.currentEvalId)
                    .then((dataDirty) => {
                        this.disabledGroup = false;
                        dataDirty.pedagogicalApproach = Object.keys(dataDirty.pedagogicalApproach).map(k => dataDirty.pedagogicalApproach[k]);
                        areaId = parseInt(this.$stateParams.subjectAreaId) || dataDirty.subjectAreaId;
                        this.subjectAreaId = parseInt(this.$stateParams.subjectAreaId) || dataDirty.subjectAreaId;
                        this.areaIdentifier = areaId;
                        this.chosenGroup = dataDirty.pedagogicalApproach.find(x => x.subjectArea.id === this.subjectAreaId);
                        this.hiddenAreas = (dataDirty.ignoredSubjectAreas.length === 0) ? {} : dataDirty.ignoredSubjectAreas;

                        if (this.chosenGroup) {
                            Object.keys(this.chosenGroup.answers).forEach((answer) => {
                                qParam = this.chosenGroup.answers[answer].question.parameter;
                                qId = this.chosenGroup.answers[answer].question.id;
                                qPin = this.chosenGroup.answers[answer].pin;
                                qGlass = this.chosenGroup.answers[answer].magnifyingGlass;
                                qHidden = this.chosenGroup.answers[answer].hidden;
                                let c = parametersTemp.find(x => x.parameter === qParam).questions;
                                c = Object.keys(c).map(k => c[k]); // convert to array

                                question = c.find(y => y.id === qId);
                                question.pin = qPin;
                                question.magnifyingGlass = qGlass;
                                question.hidden = qHidden;
                                question.question = question.id;
                                this.answers.push(question); // add to data to send
                            });
                            parametersTemp.justification = this.chosenGroup.justification;
                        }
                        this.hiddenParameters = this.chosenGroup && this.chosenGroup.ignoredParameters &&
                        Object.keys(this.chosenGroup.ignoredParameters).length > 0 ?
                            this.chosenGroup.ignoredParameters :
                            {};

                        this.hiddenQuestions = this.chosenGroup && this.chosenGroup.ignoredQuestions &&
                        this.chosenGroup.ignoredQuestions.length > 0 ?
                            this.chosenGroup.ignoredQuestions :
                            {};
                        this.parameters = parametersTemp;

                        if (this.hiddenAreas[this.areaIdentifier] || (this.hiddenSkills && this.hiddenSkills[this.skillId])) {
                            this.disabledGroup = true;
                            for (let param of this.parameters) {
                                this.hideThisParam(true, param);
                                this.hiddenParameters[param.parameter] = true;
                            }
                        }

                        if(evaluationService.isAfterFinish(evaluationData.status)) {
                            this.isFinished = true;
                            evaluationService.getOthers('pedagogical_approaches', dataDirty.isMini, dataDirty.id).then((othersData) => {
                                this.othersScores = othersData;

                                this.othersScores.forEach(other => {
                                    const otherSavedData = other.pedagogicalApproaches.find(y => y.parameter === +this.$stateParams.activeParameter);
                                    const otherAnswers = otherSavedData.answers;
                                    other.questions = this.questions.map(e => Object.assign({}, e, {
                                        hidden: otherAnswers ? (otherAnswers.find(z =>z.question.id === e.id) ?
                                            otherAnswers.find(z =>z.question.id === e.id).hidden : false) : false,
                                        pin: otherAnswers ? (otherAnswers.find(z => z.question.id === e.id) ?
                                            "" + otherAnswers.find(z => z.question.id === e.id).pin : null) : null,
                                        magnifyingGlass: otherAnswers ? (otherAnswers.find(z => z.question.id === e.id) ?
                                            "" + otherAnswers.find(z => z.question.id === e.id).magnifyingGlass : null) : null,
                                    }));
                                    other.summary = {
                                        justification: otherSavedData.justification
                                    };
                                });

                            });
                        }

                        this.answersCopy = angular.copy(this.answers);
                        this.hiddenSkillsCopy = angular.copy(this.hiddenSkills);
                        this.hiddenQuestionsCopy = angular.copy(this.hiddenQuestions);
                        this.hiddenParametersCopy = angular.copy(this.hiddenParameters);
                        this.hiddenAreasCopy = angular.copy(this.hiddenAreas);

                        this.paramsResults = calculateParamScore(this.parameters);
                        this.overallScore = calculateOverallScore(this.paramsResults);
                        drawScoreRuler(this.paramsResults);
                    });
            }, true);
        });

        this.setAnswerValue = (answer) => {
            if (this.answers.indexOf(answer) === -1) {
                answer.question = answer.id;
                this.answers.push(answer);
            }
        };

        this.hideThisParam = (hidden, parameter) => {
            parameter.hidden = hidden === true;
        };

        this.hideThisQuestion = (question) => {
            this.setAnswerValue(question);
            question.pin = null;
            question.magnifyingGlass = null;
        };

        this.hideAllParams = (hidden, skillOrAreaId) => {
            if (hidden === true) {
                for (let param of this.parameters) {
                    this.hideThisParam(true, param);
                    this.hiddenParameters[param.parameter] = true;
                }
                this.disabledGroup = true;
            } else {
                for (let param of this.parameters) {
                    this.hideThisParam(false, param);
                    this.hiddenParameters[param.parameter] = false;
                    this.disabledGroup = false;
                }
            }
        };

        this.handleNextButton = (redirectEnabled) => {
            this.errors = {};
            if (this.answers) {
                const data = {
                    skill: this.skillId,
                    subjectArea: parseInt(this.$stateParams.subjectAreaId) || this.subjectAreaId,
                    justification: this.parameters.justification ? this.parameters.justification : '',
                    items: this.answers,
                    ignoredParameters: this.hiddenParameters,
                    ignoredQuestions: this.hiddenQuestions,
                    ignoredSkills: this.hiddenSkills,
                    ignoredAreas: this.hiddenAreas,
                };
                this.stateChangeCheck = false;

                evaluationService.savePedagogicalApproachAnswers(this.currentEvalId, data, true).then((response) => {
                    if (redirectEnabled) {
                        if (response) {
                            goToNextArea();
                        }
                    }
                });
            } else {
                this.parameters.showErrors = true;
            }
        };

        this.switchToResults = () => {
            this.state = 'results';
            this.paramsResults = calculateParamScore(this.parameters);
            this.overallScore = calculateOverallScore(this.paramsResults);
            drawScoreRuler(this.paramsResults);
        };
    }

    listener2() {
        this.$scope.$on('CHANGE_SKILL', () => {
            this.errors = {};
            if (this.answers) {
                const data = {
                    skill: this.skillId,
                    subjectArea: parseInt(this.$stateParams.subjectAreaId) || this.subjectAreaId,
                    justification: this.parameters.justification ? this.parameters.justification : '',
                    items: this.answers,
                    ignoredParameters: this.hiddenParameters,
                    ignoredQuestions: this.hiddenQuestions,
                    ignoredSkills: this.hiddenSkills,
                    ignoredAreas: this.hiddenAreas,
                };
                this.stateChangeCheck = false;

                this.evaluationService.savePedagogicalApproachAnswers(this.currentEvalId, data, true);
            }
        });
    }

    listener() {
        this.errors = {};
        if (this.answers) {
            const data = {
                skill: this.skillId,
                subjectArea: parseInt(this.fromParams.subjectAreaId) || this.subjectAreaId,
                justification: this.parameters.justification ? this.parameters.justification : '',
                items: this.answers,
                ignoredParameters: this.hiddenParameters,
                ignoredQuestions: this.hiddenQuestions,
                ignoredSkills: this.hiddenSkills,
                ignoredAreas: this.hiddenAreas,
            };
            this.stateChangeCheck = false;

            this.evaluationService.savePedagogicalApproachAnswers(this.currentEvalId, data, true);
        }
    }


    $onDestroy() {
        if ((!angular.equals(this.answersCopy, this.answers) ||
            !angular.equals(this.hiddenSkillsCopy, this.hiddenSkills) ||
            !angular.equals(this.hiddenParametersCopy, this.hiddenParameters) ||
            !angular.equals(this.hiddenParametersCopy, this.hiddenParameters) ||
            !angular.equals(this.hiddenAreasCopy, this.hiddenAreas)) &&
            this.stateChangeCheck && !this.isFinished) {
            this.$timeout(() => {
                this.handleNextButton(false);
            }, 0);
        }
    }
}

ParametersController.$inject = [
    '$scope',
    '$stateParams',
    '$timeout',
    '$location',
    '$filter',
    '$state',
    'EvaluationService',
    'PedagogicalService',
    '$rootScope',
    'RulerService',
];

export default ParametersController;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepPedagogicalApproach/pages/parameters/parametersController.js